import {
  TweenMax,
  Power4,
  Power2,
  TimelineMax,
  Elastic,
} from 'gsap/TweenMax';
import Apollo from '@adoratorio/apollo';
import loop from '@/scripts/loop';
import CoreGroup from './stage/CoreGroup';
import store from '@/store';

const Cursor = {
  ref: null,

  init(cursor) {
    this.pathLenght = 278.42236328125;
    this.cursorSvg = cursor.querySelector('.cursor__polygon');
    this.progressLine = cursor.querySelector('.polygon__progress');
    this.cursorCaption = cursor.querySelector('.cursor__caption');
    this.progressLine.style.strokeDashoffset = `-${this.pathLenght}px`;
    this.progressLine.style.strokeDasharray = `${this.pathLenght}px`;
    this.state = undefined;

    this.targets = [
      {
        id: 'apollo-dots',
        elements: Array.from(document.querySelectorAll('.navigator__dot')),
        magnetism: {
          mode: Apollo.MODE.PULL,
          easing: {
            mode: Apollo.EASING.OUT_CUBIC,
            duration: 300,
          },
        },
        offset: { x: 10, y: 10 },
      },
      {
        id: 'apollo-waves',
        elements: Array.from(document.querySelectorAll('.sound-wave')),
        magnetism: {
          mode: Apollo.MODE.PULL,
          easing: {
            mode: Apollo.EASING.OUT_CUBIC,
            duration: 300,
          },
        },
        offset: { x: 0, y: 0 },
      },
    ];

    const config = {
      mode: Apollo.FOLLOW.CURSOR,
      type: Apollo.TYPE.HTML,
      cursor,
      easing: {
        mode: Apollo.EASING.OUT_CUBIC,
        duration: 400,
      },
      aion: loop,
      targets: this.targets,
    };

    Cursor.ref = new Apollo(config);

    this.cursorAnimation = null;
  },

  onMousedown(event, callback) {
    if (this.state === 'drag' || this.state === undefined) return;

    if (this.state === 'close') {
      const tl = new TimelineMax({
        onStart: () => {
          this.state = 'hold';
          callback();
        },
      });

      tl.addLabel('start')
        .to(this.cursorSvg, 1, { scale: 1, ease: Elastic.easeOut.config(1, 0.5) }, 'start')
        .to(this.progressLine, 1, { strokeDashoffset: `-${this.pathLenght}px` }, 'start')
        .to(this.cursorCaption, 0.3, { autoAlpha: 0 }, 'start');
    } else {
      this.state = 'holding';
      TweenMax.killTweensOf(this.progressLine);
      this.tlModels = CoreGroup.enterPageHold(store.state.currentIndex);
      const tween = TweenMax.to(this.progressLine, 1, {
        strokeDashoffset: 0,
        ease: Power2.easeIn,
        onUpdate: () => {
          this.tlModels.seek(tween.progress() / 2);
        },
        onComplete: () => {
          this.toClose();
          callback();
        },
      });
    }
  },

  onMouseup() {
    if (this.state === 'close' || this.state === undefined) return;
    this.state = 'hold';

    TweenMax.killTweensOf(this.progressLine);
    TweenMax.to(this.progressLine, 2.5, {
      strokeDashoffset: `-${this.pathLenght}px`,
      ease: Power4.easeOut,
    });
    if (this.tlModels !== undefined) this.tlModels.kill();
    CoreGroup.leavePageHold(store.state.currentIndex);
  },

  tiltCaption(text) {
    this.cursorCaption.innerHTML = text;
    return TweenMax.fromTo(this.cursorCaption, 0.4, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      yoyo: true,
      repeat: 7,
      delay: 0.3,
    });
  },

  toClose() {
    this.state = 'close';
    this.cursorCaption.innerHTML = '';
    if (this.cursorAnimation !== null) this.cursorAnimation.kill();
    this.cursorAnimation = new TimelineMax();

    this.cursorAnimation.addLabel('start')
      .to(this.cursorSvg, 0.6, { scale: 1, ease: Elastic.easeOut.config(1, 0.5) }, 'start')
      .to(this.progressLine, 1, { strokeDashoffset: 0 }, 'start')
      .to(this.cursorCaption, 0.3, { autoAlpha: 1 }, 'start');

    return this.cursorAnimation;
  },

  toDrag() {
    this.state = 'drag';
    if (this.cursorAnimation !== null) this.cursorAnimation.kill();
    this.cursorAnimation = new TimelineMax({
      onComplete: () => {
        this.tiltCaption('Drag');
      },
    });

    this.cursorAnimation.addLabel('start')
      .to(this.cursorSvg, 0.4, { scale: 0.8, ease: Elastic.easeOut.config(1, 0.5) }, 'start');

    return this.cursorAnimation;
  },

  toNormal() {
    this.state = 'hold';
    this.cursorCaption.innerHTML = '';
    return TweenMax.to(this.cursorSvg, 1, { scale: 1, ease: Elastic.easeOut.config(1, 0.5) });
  },

  toZoom() {
    this.state = 'hold';
    this.cursorCaption.innerHTML = '';
    return TweenMax.to(this.cursorSvg, 1, { scale: 1.4, ease: Elastic.easeOut.config(1, 0.5) });
  },

  toDot() {
    this.state = 'hold';
    this.cursorCaption.innerHTML = '';
    return TweenMax.to(this.cursorSvg, 1, { scale: 0.55, ease: Elastic.easeOut.config(1, 0.5) });
  },
};

export default Cursor;
